<template>
  <div class="create-form-container">
    <!-- <section id="header">
      <a href="/" class="logo">FUNTINY</a>
    </section> -->
    <div class="capsule">
      <div class="home">
        <section class="create-form">
          <transition :name="transition">
            <section v-if="step == 1" :key="1">
              <h3>Where are you?</h3><br />
              <RadioToggleButtons
                v-model="city"
                :values="cityOptions"
                color="purple"
                textColor="#000"
                selectedTextColor="#fff"
                v-on:change="onLocation"
              />
              <section v-if="city">
                <div class="field">
                  <label class="label"
                    >What do you want to do about transportation in
                    {{ city }}?</label
                  >
                  <RadioToggleButtons
                    v-model="type"
                    :values="typeOptions"
                    color="purple"
                    textColor="#000"
                    selectedTextColor="#fff"
                    v-on:change="onSelect"
                  />
                  <p>Go ahead. We'll do the work. You can choose anonymity.</p>
                </div>
              </section>
            </section>
            <section v-if="step == 2" :key="2">
              <h4 v-if="type == 'bitch'">
                Hey! Complain away about transportation in {{ city }}.
              </h4>
              <h4 v-else-if="type == 'cheer'">
                Hey! Praise the {{ city }} transportation Gods.
              </h4>
              <div class="field">
                <label class="label">Topic (required)</label>
                <div class="control">
                  <input
                    autofocus
                    type="text"
                    placeholder="Subway or Caltrain"
                    v-bind:class="{ error: errors.topic }"
                    v-model="topic"
                    v-on:blur="onBlurField('topic')"
                    ref="topic"
                  /><br />
                </div>
              </div>
              <div class="field">
                <label class="label detail-label">Details (required)</label>
                <p class="text-right text-medium chars-left">
                  Characters Left = {{ textRemainingCount }}
                </p>
                <div class="control">
                  <textarea
                    placeholder=""
                    :maxlength="maxCharacters"
                    v-bind:class="{ error: errors.text }"
                    v-model="text"
                    v-on:blur="onBlurField('text')"
                    ref="text"
                  /><br />
                </div>
              </div>
              <div class="field">
                <label class="label">Email (optional)</label>
                <div class="control">
                  <input
                    autocomplete="email"
                    type="email"
                    placeholder=""
                    v-model="email"
                    v-on:blur="onBlurField('email')"
                  />
                  <small v-if="errors.email">{{ errors.email }}</small>
                  <br />
                </div>
                <div class="control">
                  <input type="checkbox" id="anonymous" v-model="anonymous" />
                  <label class="label" for="anonymous"
                    >Stay Anonymous when reporting</label
                  >
                  <br />
                </div>
              </div>
            </section>
            <section v-if="step == stepTotal + 1" :key="stepTotal + 1">
              <div class="field">
                <h3>
                  Message sent! For more info contact:
                  <a href="mailto:yo@funtiny.com">yo@funtiny.com</a>
                </h3>
                <br />
              </div>
              <button class="button primary small" v-on:click="restart">
                RESTART
              </button>
            </section>
          </transition>
          <br />
          <button
            class="button primary small"
            v-if="step > 1 && step < stepTotal"
            v-on:click="next"
          >
            Go!
          </button>
          <button
            class="button primary small"
            v-if="step === stepTotal"
            v-on:click="next"
          >
            Send!
          </button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

const APIUrl = IS_PRODUCTION
  ? 'https://funtiny.appspot.com/'
  : 'http://localhost:5000';

export default {
  name: 'CreateForm',
  data() {
    return {
      maxCharacters: 280,
      step: 1,
      stepTotal: 2,
      anonymous: false,
      city: '',
      cityOptions: [
        { label: 'San Francisco', value: 'San Francisco' },
        { label: 'New York', value: 'New York' }
      ],
      email: '',
      errors: {
        email: '',
        text: false,
        topic: false
      },
      text: '',
      type: '',
      topic: '',
      typeOptions: [
        { label: 'bitch', value: 'bitch' },
        { label: 'cheer', value: 'cheer' }
      ],
      transition: 'slide-fade-forward'
    };
  },
  methods: {
    sendVoice() {
      const path = `${APIUrl}/api/voices/`;
      const data = {
        anonymous: this.anonymous,
        city: this.city,
        email: this.email,
        type: this.type,
        text: this.text,
        topic: this.topic
      };
      axios
        .post(path, data)
        .then(res => {
          console.log(res.data);
          this.$emit('onFormSuccess');
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error);
        });
    },
    onLocation(city) {
      this.$emit('onLocation', city);
      this.next();
    },
    onSelect() {
      this.next();
    },
    next() {
      switch (this.step) {
        case 1:
          // 1
          if (!this.city || !this.type) {
            return;
            // 1.5
          } else if (this.city && this.type) {
            break;
          }
          break;

        case 2:
          if (!this.topic || !this.text || this.text > this.maxCharacters) {
            this.onBlurField('topic');
            this.onBlurField('text');
            if (!this.topic) this.$refs.topic.focus();
            else if (!this.text) this.$refs.text.focus();
            return;
          }
          try {
            if (this.email) this.checkEmail();
            this.sendVoice();
          } catch (error) {
            return;
          }
          break;

        default:
          break;
      }
      this.transition = 'slide-fade-forward';
      this.step++;
    },
    prev() {
      this.transition = 'slide-fade-backward';
      this.step--;
    },
    onBlurField(field) {
      switch (field) {
        case 'email':
          if (this.email.trim()) {
            try {
              this.checkEmail();
            } catch (error) {
              this.errors.email = 'Invalid email';
              return;
            }
          }
          this.errors.email = '';
          break;
        case 'topic':
          this.errors.topic = !this.topic.trim();
          break;
        case 'text':
          this.errors.text = !this.text.trim();
          break;
        default:
          break;
      }
    },
    checkEmail() {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.email.trim())) {
        throw new Error('Email is not valid');
      }
    },
    restart() {
      this.step = 1;
      this.city = '';
      this.email = '';
      this.type = '';
      this.text = '';
      this.topic = '';
      this.anonymous = false;
    }
  },
  computed: {
    textRemainingCount() {
      return this.maxCharacters - this.text.length;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 20px 0 0;
}

.slide-fade-forward-enter-active,
.slide-fade-backward-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-forward-enter,
.slide-fade-forward-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.slide-fade-backward-enter,
.slide-fade-backward-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.chars-left,
.detail-label {
  display: inline-block;
}
.chars-left {
  float: right;
  margin: 0;
}
</style>

<style lang="scss">
label.radio-toggle-button {
  border-radius: 8px !important;
}

input[type='checkbox'] + label {
  padding-right: 0 !important;
}

input[type='checkbox'] + label:before {
  top: 2px !important;
}
button:focus {
  outline: none;
}

.text-right {
  text-align: right;
}
.text-medium {
  font-size: medium;
}
.control {
  small {
    color: red;
    display: block;
    margin: 10px 0;
  }

  input.error,
  input.error:focus,
  textarea.error,
  textarea.error:focus {
    border-color: #f44336;
  }

  input.error:focus,
  textarea.error:focus {
    box-shadow: 0 0 0 1px #f44336;
  }
}
</style>
